module.exports = __webpack_public_path__ + "730d9fa6efbb5e5859e34b21ff897636.svg";